/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoryDto } from './categoryDto';
import { DietDto } from './dietDto';
import { AllergenDto } from './allergenDto';
import { BromatologicalValueDto } from './bromatologicalValueDto';
import { ArticleIngredientDto } from './articleIngredientDto';


export interface ArticleDto { 
    id?: number;
    name?: string | null;
    description?: string | null;
    imageUrl?: string | null;
    code?: string | null;
    price?: number | null;
    points?: number | null;
    isFree?: boolean;
    rating?: number | null;
    isFavorite?: boolean;
    categoryId?: number;
    articlePriceId?: number;
    category?: CategoryDto;
    allergens?: Array<AllergenDto> | null;
    bromatologicalValues?: Array<BromatologicalValueDto> | null;
    bromatologicalValuesToShow?: Array<BromatologicalValueDto> | null;
    diets?: Array<DietDto> | null;
    articleIngredients?: Array<ArticleIngredientDto> | null;
    co2?: number | null;
}

